import { formatArr } from "@/utils/util";
import { getExaminerCourse } from "@/services/courseEn";

export default {
  namespaced: true,
  state: {
    courseList: []
  },
  actions: {
    async getExaminerCourseList({ dispatch, commit }, payload) {
      const params = {
        startTime: payload[0].date,
        endTime: payload[payload.length - 1].date
      };
      const { list } = (await getExaminerCourse({ ...params })) || [];
      commit("UPDATE_VALUE_STATES", {
        key: "courseList",
        data: formatArr(payload, list)
      });
    }
  },
  mutations: {
    UPDATE_VALUE_STATES(state, payload) {
      const { key, data } = payload;
      state[key] = data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/courseEn.js